import { useQuery } from '@tanstack/react-query'
import { buildVersionedUrl } from '@/common/utils/buildVersionedUrl'

/**
 * Hook to fetch a versioned URL with ETag-based cache busting.
 * Uses React Query for caching and automatic state management.
 *
 * @param baseUrl - The base URL of the resource
 * @param options - Optional React Query options
 */
export default function useQueryVersionedUrl(
	baseUrl: string,
	options?: { enabled?: boolean },
) {
	return useQuery({
		queryKey: ['versionedUrl', baseUrl],
		queryFn: () => buildVersionedUrl(baseUrl),
		staleTime: 0, // Always check for new ETag
		...options,
	})
}
